// extracted by css-extract-rspack-plugin
export default {"cls1":"YourPaperCard-cls1_N2m","cls2":"YourPaperCard-cls2_iR5 YourPaperCard-cls1_N2m"};